import { useState } from 'react';
import { generateRoomSecret, buildRoomURL } from '../crypto/room-url';
import { createRoom, type CreateRoomResponse } from '../api/rooms';
import { HealthStatus } from '../components/HealthStatus';

export function CreateRoomPage() {
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function handleCreate() {
    setCreating(true);
    setError(null);
    try {
      const roomSecret = generateRoomSecret();
      const resp: CreateRoomResponse = await createRoom();
      sessionStorage.setItem('crossclip-mgmt-token', resp.managementToken);
      sessionStorage.setItem('crossclip-room-creds', JSON.stringify({ roomSecret, accessToken: resp.accessToken }));
      sessionStorage.setItem('crossclip-is-host', '1');
      const url = buildRoomURL(resp.roomId, roomSecret, resp.accessToken);
      window.location.href = url;
    } catch (err) {
      setError(err instanceof Error ? err.message : 'failed to create room');
    } finally {
      setCreating(false);
    }
  }

  return (
    <div>
      <div className="card" style={{ textAlign: 'center', marginTop: '3rem' }}>
        <h1>CrossClip</h1>
        <p className="muted" style={{ marginBottom: '1.5rem' }}>跨设备加密临时剪贴板</p>
        <HealthStatus />
        <div className="stack" style={{ marginTop: '1.5rem', alignItems: 'center' }}>
          <button onClick={handleCreate} disabled={creating} style={{ minWidth: '200px' }}>
            {creating ? '创建中…' : '创建房间'}
          </button>
          <a href="/join" className="muted">用配对码加入</a>
        </div>
        {error && <p role="alert" style={{ marginTop: '1rem' }}>{error}</p>}
      </div>
    </div>
  );
}
